import styled, { CSSProperties } from 'styled-components';
import { ChangeEvent, FocusEvent, MouseEvent, useMemo } from 'react';
import { v4 } from 'uuid';

const StyledSelectContainer = styled.div`
	width: 100%;
	position: relative;
`;

const StyledSelect = styled.select`
	width: 100%;
	height: auto;
	padding: 0.55rem 1.5rem;

	border: 1px solid ${({ theme }) => theme.input_border};
	background: ${({ theme }) => theme.input_bg};
	outline: none;

	font-family: ${({ theme }) => theme.FONTS_PRIMARY};
	color: ${({ theme }) => theme.input_fg};
	font-size: 1.2rem;
	font-weight: 400;

	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	border-radius: 4px;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.4;
	}
	&:focus {
		border-color: ${({ theme }) => theme.input_border_active};
	}

	option {
		background-color: black;
		color-scheme: dark;
	}
`;

interface SelectProps {
	value: string;
	onChange: (value: string, e?: ChangeEvent<HTMLSelectElement>) => void;
	id?: string;
	style?: CSSProperties;
	styleInput?: CSSProperties;
	className?: string;
	disabled?: boolean;
	options: { text: string; value: string }[];
	onFocus?: (e?: FocusEvent<HTMLSelectElement>) => void;
	onBlur?: (e?: FocusEvent<HTMLSelectElement>) => void;
	onChangeMap?: (value: string) => string;
}

export function Select(props: SelectProps) {
	const { id, style, styleInput, value, className, disabled, onFocus, onBlur, onChange, onChangeMap, options } =
		props;

	const onInputFocus = (e: FocusEvent<HTMLSelectElement>) => {
		onFocus?.(e);
	};

	const onInputBlur = (e: FocusEvent<HTMLSelectElement>) => {
		onBlur?.(e);
	};

	const onInputChange = (e: ChangeEvent<HTMLSelectElement>) => {
		const mappedValue = onChangeMap ? onChangeMap(e.target.value) : e.target.value;
		onChange?.(mappedValue, e);
	};

	const onRightClickTask = (e: MouseEvent) => {
		if (e) e.stopPropagation();
	};

	const CUSTOM_ID = useMemo(() => {
		if (id) return id;
		return v4();
	}, [id]);

	return (
		<StyledSelectContainer id={id && id} style={style && style} className={className && className}>
			<StyledSelect
				disabled={disabled}
				onFocus={onInputFocus}
				onBlur={onInputBlur}
				onChange={onInputChange}
				value={value}
				style={styleInput && styleInput}
				onContextMenu={onRightClickTask}
			>
				{options.map((option, index) => (
					<option value={option.value} key={`option_${index}_${CUSTOM_ID}`}>
						{option.text}
					</option>
				))}
			</StyledSelect>
		</StyledSelectContainer>
	);
}
